import { networkService } from "services/networkService";
import {
  METHOD_LIST,
  METHOD_CREATE,
  METHOD_UPDATE,
  METHOD_DELETE,
  METHOD_DETAIL,
  METHOD_VERSION_LIST,
  METHOD_VERSION_CREATE,
  METHOD_VERSION_UPDATE,
  METHOD_VERSION_DELETE,
  METHOD_VERSION_DETAIL
} from "constants/admin/masters/cluster";
class clusterService {
  //clusters
  getAll = (data) => {
    return networkService
      .post(METHOD_LIST, data)
      .then((response) => response.data);
  };
  getDetail = (id) => {
    const updatedMethodName = METHOD_DETAIL.replace("{ID}", id);
    return networkService
      .get(updatedMethodName)
      .then((response) => response.data);
  };
  create = (data) => {
    return networkService
      .post(METHOD_CREATE, data)
      .then((response) => response.data);
  };
  update = (data, id) => {
    const updatedMethodName = METHOD_UPDATE.replace("{ID}", id);
    return networkService
      .post(updatedMethodName, data)
      .then((response) => response.data);
  };
  delete = (id,is_delete=false) => {
    const updatedMethodName = METHOD_DELETE.replace("{ID}", id);
    return networkService
      .delete(updatedMethodName,{ data: { is_delete }})
      .then((response) => response.data);
  };

  //clusterversion  
  getAllVersions = (data) => {
    return networkService
      .post(METHOD_VERSION_LIST, data)
      .then((response) => response.data);
  };
  getVersionDetail = (id) => {
    const updatedMethodName = METHOD_VERSION_DETAIL.replace("{ID}", id);
    return networkService
      .get(updatedMethodName)
      .then((response) => response.data);
  };
  createVersion = (data) => {
    return networkService
      .post(METHOD_VERSION_CREATE, data)
      .then((response) => response.data);
  };
  updateVersion = (data, id) => {
    const updatedMethodName = METHOD_VERSION_UPDATE.replace("{ID}", id);
    return networkService
      .post(updatedMethodName, data)
      .then((response) => response.data);
  };
  deleteVersion = (id,is_delete=false) => {
    const updatedMethodName = METHOD_VERSION_DELETE.replace("{ID}", id);
    return networkService
      .delete(updatedMethodName,{ data: { is_delete }})
      .then((response) => response.data);
  };
}
export default clusterService;
